export default "__VITE_ASSET__Dh$8Pm2U__"